<template>
    <ModalFrame :title="data.name" @close-modal="$emit('close-modal')">
        <template #content>
            <VMarkdownView class="about-message" :content="data.aboutMessage" />

            <div class="_btn-container">
                <BasicButton rounded="xl" bgColor="#435A64" @click="openWpp">
                    <i class="fab fa-whatsapp fa-2x"></i> Contratar
                </BasicButton>
            </div>
        </template>
    </ModalFrame>
</template>

<script setup>
import { VMarkdownView } from 'vue3-markdown'

import ModalFrame from '../../containers/ModalFrame.vue'
import BasicButton from '../buttons/BasicButton.vue'

import variables from '../../variables'

defineProps({
    data: {
        type: Object,
        required: true,
    },
})

defineEmits(['close-modal'])

function openWpp() {
    window.open(
        `https://api.whatsapp.com/send?phone=${variables.links.contactPhone}&text=Olá%2C%20vim%20da%20plataforma%20da%20Plano%20e%20quero%20conhecer%20mais, ${variables.text.brand}!`,
        '_blank',
    )
}
</script>

<style lang="scss">
.about-message {
    margin: 12px;
    line-height: 20px;
    width: 95%;
}

._btn-container {
    display: flex;
    justify-content: flex-end;
    padding: 16px;
    margin-top: 16px;
    border-top: 1px solid $light-grey;
    width: 100%;

    i {
        margin-right: 8px;
        margin-bottom: 2px;
    }
}
</style>
